import { StringValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { requiredNonEmptyString, validatePayload, } from '../../utils/validate-payload.js';
export const enableDidYouMean = createAction('didYouMean/enable');
export const disableDidYouMean = createAction('didYouMean/disable');
export const disableAutomaticQueryCorrection = createAction('didYouMean/automaticCorrections/disable');
export const enableAutomaticQueryCorrection = createAction('didYouMean/automaticCorrections/enable');
export const applyDidYouMeanCorrection = createAction('didYouMean/correction', (payload) => validatePayload(payload, requiredNonEmptyString));
export const setCorrectionMode = createAction('didYouMean/automaticCorrections/mode', (payload) => validatePayload(payload, new StringValue({
    constrainTo: ['next', 'legacy'],
    emptyAllowed: false,
    required: true,
})));
